import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Loading, Message } from "commons";

import { ShowInClientPortal } from "./ShowInClientPortal";
import { dateRanges } from "./SelectDateRangeWithType";

export class LoadingStateDisplay extends PureComponent {
    render() {
        const msgFontSize = this.props.isClientPortal ? "1.5em" : "1em";
        return (
            <ShowInClientPortal isClientPortal={this.props.isClientPortal}>
                <Message
                    error
                    text={
                        "The PDF download is not working at the moment. Please try it again and if the problem persists, please contact support."
                    }
                    shown={this.props.printFailed}
                    fontSize={msgFontSize}
                />
                <Message
                    error
                    text={
                        "Transactions cannot be displayed for the selected account, please contact support."
                    }
                    shown={this.props.isError}
                    fontSize={msgFontSize}
                />
                <Message
                    warning
                    text={
                        "No transactions have occurred within the selected date period. Please extend your date range."
                    }
                    shown={this.props.isIncomeHistory ? this.props.noIHData : this.props.noData}
                    fontSize={msgFontSize}
                />
                <Message
                    warning
                    text={
                        <>
                            <p>
                                Please take care when filtering transactions to determine
                                contributions within the tax year as the date filtering of this tool
                                applies to the effective and processed dates of the payments only.
                            </p>
                            <p>
                                Please use the ‘execution date’ option if you want to include the
                                buys resulting from the payments.
                            </p>
                        </>
                    }
                    shown={
                        !this.props.isClientPortal &&
                        (this.props.selectedDateRange === dateRanges.CURRENT_TAX_YEAR ||
                            this.props.selectedDateRange === dateRanges.LAST_TAX_YEAR)
                    }
                    fontSize={msgFontSize}
                />
                <LoadingContainer>
                    <Loading displayWhen={!this.props.loading} size={25}>
                        <div />
                    </Loading>
                </LoadingContainer>
            </ShowInClientPortal>
        );
    }
}

const LoadingContainer = styled.div`
    width: 100%;
    clear: both;
    text-align: center;
`;

LoadingStateDisplay.defaultProps = {
    printError: false,
    isError: false,
    noData: false,
    noIHData: false
};

LoadingStateDisplay.propTypes = {
    loading: PropTypes.bool,
    isClientPortal: PropTypes.bool,
    isIncomeHistory: PropTypes.bool,
    isError: PropTypes.bool,
    noData: PropTypes.bool,
    noIHData: PropTypes.bool,
    printFailed: PropTypes.bool,
    selectedDateRange: PropTypes.string
};
